// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"7af38dd3","645":"2eb0417d","661":"a1179b24","777":"3314c564"}[chunkId] + ".chunk.js";
};